import { render, staticRenderFns } from "./otherSemEditor.vue?vue&type=template&id=27df870a&scoped=true&"
import script from "./otherSemEditor.vue?vue&type=script&lang=js&"
export * from "./otherSemEditor.vue?vue&type=script&lang=js&"
import style0 from "./otherSemEditor.vue?vue&type=style&index=0&id=27df870a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27df870a",
  null
  
)

export default component.exports